import { Component, Input, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ElementService } from '../../services/element.service';
import {Element} from '../../services/element';

@Component({
  selector: 'submission-form',
  templateUrl: './submission-form.component.html',
  styleUrls: ['./submission-form.component.css']
})
export class SubmissionFormComponent {
  @Input() element;
  @Input() elementId;
  @Input() edit;
  @Input() metaFields;
  @ViewChild('elementForm') elementForm;
  fields = [];

  constructor(
    private modalService: NgbModal,
    private elementService: ElementService
  ) { }

  open(content) {
    if (this.elementId) {
      this.elementService.getById(this.elementId).subscribe((element: Element) => {
        this.element = element;
        this.fields = element.fields;

        this.openModal(content);
      });
    } else {
      this.fields = this.element.fields;
      this.fields = this.fields.concat(this.metaFields);
      this.openModal(content);
    }
  }

  openModal(content) {
    this.fields = this.element.fields;
    this.fields = this.fields.concat(this.metaFields);
    this.element.displayedFields = [];

    // Convert the element fields into a FormGroup
    let group: any = {};
    this.fields.forEach(field => {
      if (!field) { return; };

      if (field.hidden) {
        return;
      }
      if (field.type === 'radio' || field.type === 'select') {
        field.options = field.options.split(',');
      } else {
        field.type = 'text';
      }
      if (field.required) {
        group[field.id] = new FormControl(field.value || '', Validators.required);
      } else {
        group[field.id] = new FormControl(field.value || '');
      }

      this.element.displayedFields.push(field);
    });

    this.elementForm = new FormGroup(group);

    this.modalService.open(content).result.then(result => {

    }).catch(reason => {});
  }

}



// WEBPACK FOOTER //
// ./src/app/components/submission-form/submission-form.component.ts